var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enhanced-qr-container"},[_c('div',{staticClass:"qr-wrapper",style:(_vm.wrapperStyle)},[_c('canvas',{ref:"qrCanvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }